import { useMutation, useQueryClient } from 'react-query';

import { binderManagementBDXAxios } from '../../binderManagement.api';
import { BDX_DATA, BDX_EXCEPTIONS_COUNT } from '../../binderManagement.queryKeys';
import { useHandleError } from '../../binderManagement.utils';

export const useDismissBDXValidationException = () => {
  const queryClient = useQueryClient();

  const handleError = useHandleError({
    file: 'binderManagement.reporting.mutation.useDismissBDXValidationException',
    warning: 'notification.bdxExceptions.fail',
  });

  const handleSuccess = ({ requestId }) => {
    queryClient.invalidateQueries(BDX_DATA);
    queryClient.invalidateQueries([BDX_EXCEPTIONS_COUNT, requestId]);
  };

  return useMutation(
    async ({ requestId, rowId, columnName }) => {
      const data = await binderManagementBDXAxios.put('exceptions/validation/dismiss', { requestId, rowId, columnName });
      return { requestId, data };
    },
    {
      onSuccess: handleSuccess,
      onError: handleError,
    }
  );
};
